import { createI18n } from 'vue-i18n';

import enUS from './locales/enUS.json';
import he from './locales/he.json';

// 1. Define your "Source of Truth" for types based on the new enUS file
type MessageSchema = typeof enUS;

// 2. Define supported languages (Updated 'en' to 'enUS')
export const SUPPORTED_LANGS = ['enUS', 'he'] as const;

// 3. This creates the union type: 'enUS' | 'he'
export type SupportedLang = typeof SUPPORTED_LANGS[number];

export const DEFAULT_LANG: SupportedLang = 'enUS';

const i18n = createI18n<[MessageSchema], SupportedLang>({
    legacy: false, // Required for Composition API
    locale: DEFAULT_LANG,
    fallbackLocale: DEFAULT_LANG,
    globalInjection: true, // Allows using $t in templates without extra setup
    messages: {
        enUS,
        he
    },
});

export default i18n;